module.exports = __webpack_public_path__ + "static/media/banner_restroom.116e2a3e.jpg";